import { DoneIcon, ExpandIcon, SortIcon } from '@change/ds-icons';

import { Chip, SelectMenu, SelectMenuContent, SelectMenuItem, SelectMenuTriggerButton } from '@change/ds-core-ui/next';

type SortSelectorProps = {
	currentRefinement: string;
	currentLabel: string;
	sortByTitle: string;
	options: ReadonlyArray<{ label: string; value: string; subtitle: string }>;
	// FIXME(SelectMenu): Using string | number because the component requires Key type from react-aria as value
	changeSelection: (value: string | number | null) => void;
};

export const DesktopSortSelector: React.FC<SortSelectorProps> = ({
	sortByTitle,
	currentRefinement,
	currentLabel,
	options,
	changeSelection,
}) => {
	return (
		<SelectMenu
			ariaLabel={sortByTitle}
			defaultSelectedId={currentRefinement}
			onSelectionChange={changeSelection}
			data-testid="sort-selector"
			data-qa="sort-selectMenu"
		>
			<SelectMenuTriggerButton>
				{() => (
					<Chip leadingIcon={<SortIcon />} trailingIcon={<ExpandIcon />} forceInteractive>
						{sortByTitle} {currentLabel}
					</Chip>
				)}
			</SelectMenuTriggerButton>
			<SelectMenuContent className="max-h-96 max-w-96">
				{options.map((option) => (
					<SelectMenuItem
						key={option.value}
						value={option.value}
						label={option.label}
						trailingIcon={currentRefinement === option.value ? <DoneIcon /> : undefined}
						body={option.subtitle}
					/>
				))}
			</SelectMenuContent>
		</SelectMenu>
	);
};
